<script>
import dayjs from "dayjs";

export default {
  name: "Registration",
  props: {
    registration: {
      required: true,
      type: Object
    }
  },
  computed: {
    formattedRegistrationDate() {
      return dayjs(this.registration.created_at).format("lll");
    },
    formattedBirthday() {
      return this.registration && this.registration.birthday ? dayjs(this.registration.birthday).format("ll") : "n/a";
    }
  }
};
</script>

<template>

  <div>
    <div class="d-flex flex-column justify-content-center mb-4">
      <div class="card" style="width: 100%">
        <div class="card-body d-flex flex-column justify-content-start">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="card-title m-0">{{ registration.firstname }} {{ registration.lastname }}
            </h5>
            <span v-if="registration.status.value === 'validated'"
                  class="badge bg-success text-white fs-8">{{ registration.status.label }}</span>
            <span v-if="registration.status.value === 'registered'"
                  class="badge bg-warning text-white fs-6">{{ registration.status.label }}</span>
          </div>
          <ul class="list-unstyled" style="height: 5rem;">
            <li><strong>{{ $t("Email Address") }}</strong> : <span>{{ registration.email }}</span></li>
            <li><strong>{{ $t("Phone") }}</strong> : <span>{{ registration.phone.number }}</span></li>
            <li><strong>{{ $t("Birthdate") }}</strong> : <span>{{ formattedBirthday }}</span></li>
          </ul>
          <div class="mt-auto">
            <small class="text-muted">{{ formattedRegistrationDate }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>